<div class="bm--auth-form-box">
  <h1 class="common-section-title common-section-title--form">Sign up</h1>
  <div class="sign-up-page__form-box">
    <bmcore-sign-up-form></bmcore-sign-up-form>
  </div>

  <div class="sign-up-page">
    <p class="bm--auth-form__hint bm--auth-form__hint--text">Already have an account?</p>
    <a class="bm--auth-form__hint bm--auth-form__hint--link" routerLink="/sign-in">Sign In</a>
  </div>
</div>
